import { useAppDispatch, useAppSelector } from 'app/redux';
import { WizardDropdownOption } from 'common/components/WizardControls/WizardDropdown';
import { Season } from 'common/models/season';
import { FC, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { SeasonSelector, SelectedSeason } from './SeasonSelector';
import { SeasonState, seasonSlice, seasonSliceName } from './seasonSlice';

export const GlobalSeasonSelector: FC<{ isLoading: boolean }> = ({
  isLoading,
}) => {
  const dispatch = useAppDispatch();
  const { availableSeasons, selectedSeason } = useAppSelector<SeasonState>(
    state => state[seasonSliceName],
  );

  const defaultSeason: WizardDropdownOption<Season> | null = useMemo(() => {
    let season;

    if (selectedSeason) {
      season = selectedSeason;
    } else {
      season = availableSeasons?.find(season => season.isDefault);
    }

    return season ? { label: `${season.year}`, value: season } : null;
  }, [availableSeasons, selectedSeason]);

  const { control, watch } = useForm<SelectedSeason>({
    values: { season: defaultSeason },
  });

  const watchedSeason = watch('season');

  // Update store with latest selection.
  useEffect(() => {
    if (watchedSeason) {
      dispatch(seasonSlice.actions.setSeason(watchedSeason.value));
    }
  }, [dispatch, watchedSeason]);

  return (
    <SeasonSelector
      isLoading={isLoading}
      seasons={availableSeasons}
      control={control}
    />
  );
};
